import api from './axiosConfig.js'

export const leaveApi = {
    // Apply for leave (Employee)
    applyLeave: (data) => api.post('/leave/apply', data),

    // Get leave requests (Org Admin)
    getLeaveRequests: (params = {}) => api.get('/leave/requests', { params }),

    // Get my leaves (Employee)
    getMyLeaves: (params = {}) => api.get('/leave/my-leaves', { params }),

    // Update leave status (Org Admin/Approver)
    updateLeaveStatus: (leaveId, status, remarks) =>
        api.put(`/leaves/update-leave-status`, { status, remarks }, {
            headers: { 'X-ORG-ID': localStorage.getItem('org_id') },
            params: { leave_id: leaveId }
        }),

    // Get all leave types
    getLeaveTypes: () => api.get('/leave/types'),

    // Get leave balance (Employee)
    getLeaveBalance: (employeeId) => api.get('/leaves/get-leave-balance', {
        headers: { 'X-ORG-ID': localStorage.getItem('org_id') },
        params: { employee_id: employeeId },
        skipErrorToast: true,
    }),

    // Get leave stats (Employee)
    getLeaveStats: (employeeId) => api.get('/leaves/get-leave-stats', {
        headers: { 'X-ORG-ID': localStorage.getItem('org_id') },
        params: { employee_id: employeeId },
        skipErrorToast: true,
    }),

    // Get leave statistics (percentages for chart)
    getLeaveStatistics: (employeeId) => api.get('/leaves/leave-statistics', {
        headers: { 'X-ORG-ID': localStorage.getItem('org_id') },
        params: { employee_id: employeeId },
        skipErrorToast: true,
    }),

    // Org Leave Configuration
    createOrgLeaves: (data) => api.post('/leaves/create-leaves-org', data, {
        headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
    }),
    updateOrgLeaves: (data) => api.put('/leaves/update-leaves-org', data, {
        headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
    }),
    getOrgLeaves: () => api.get('/leaves/get-leaves-org', {
        headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
    }),

    // Get all leaves for Org Admin
    getAllLeaves: (params = {}) => api.get('/leaves/get-all-leaves', {
        headers: { 'X-ORG-ID': localStorage.getItem('org_id') },
        params
    }),

    // Get leave details by ID
    getLeaveDetails: (leaveId) => api.get('/leaves/get-leave-details', {
        headers: { 'X-ORG-ID': localStorage.getItem('org_id') },
        params: { leave_id: leaveId }
    }),

    // Get leave history (Employee)
    getLeaveHistory: (employeeId) => api.get('/leaves/get-leave-history', {
        headers: { 'X-ORG-ID': localStorage.getItem('org_id') },
        params: { employee_id: employeeId }
    }),

    // Cancel leave (Employee)
    cancelLeave: (leaveId, config = {}) => api.delete('/leaves/cancel-leave', {
        headers: { 'X-ORG-ID': localStorage.getItem('org_id') },
        params: { leave_id: leaveId },
        ...config
    }),
}
